import React, { Component, useEffect, useState } from "react";
import Slider from "./components/NetflixSlider";
import Axios from "axios";

import "./movie.scss";


const Home = () => {

  const [gameList, setGameList] = useState(null);
 

  useEffect(() => {
    Axios.get("https://backendexample.sanbersy.com/api/data-game")
      .then((response) => {
        setGameList(response.data);
      }).catch((err) => {        
      });
  }, []);

  return (
    <div className="app" style={{ minHeight: "100vh" }}>
      <div className="hub">
        <h3 style={{ color: "#e6739f" }}>List All Games</h3>
        {gameList ? (
          <Slider>
            {gameList.map((games) => (
              <Slider.Item movie={games} key={games.id}>
                item1dadadadad
              </Slider.Item>
            ))}
          </Slider>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Home;
